import React from "react"
import Components from "../index"
import { blokType } from "../../types"
import {
  StyledSubSection,
  StyledSubSectionContainer,
  StyledHeroLabel,
  StyledSubSectionText,
  StyledSubSectionButton,
  StyledSubSectionImage,
  StyledSubSectionHeading,
  StyledSubSectionDescription,
} from "./partials"

export interface SubSectionTitleProps {
  label: string
  title: string
  description: string
  cta_button: blokType[]
  image: blokType[]
  image_position: boolean
  remove_divider: boolean
}

export const SubSectionTitleCmp: React.FC<SubSectionTitleProps> = ({
  label,
  title,
  description,
  cta_button,
  image,
  image_position,
  remove_divider,
}) => {
  return (
    <StyledSubSection remove_divider={remove_divider}>
      <StyledSubSectionContainer image_position={image_position}>
        <StyledSubSectionText>
          {label && <StyledHeroLabel>{label}</StyledHeroLabel>}
          {title && <StyledSubSectionHeading>{title}</StyledSubSectionHeading>}
          {description && (
            <StyledSubSectionDescription>
              {description}
            </StyledSubSectionDescription>
          )}
          {cta_button && cta_button.length > 0 && (
            <StyledSubSectionButton>
              {cta_button.map((content: blokType) =>
                React.createElement(Components(content.component), {
                  key: content._uid,
                  blok: content,
                })
              )}
            </StyledSubSectionButton>
          )}
        </StyledSubSectionText>
        <StyledSubSectionImage>
          {image && image.length > 0 && (
            <div>
              {image.map((content) =>
                React.createElement(Components(content.component), {
                  key: content._uid,
                  blok: content,
                })
              )}
            </div>
          )}
        </StyledSubSectionImage>
      </StyledSubSectionContainer>
    </StyledSubSection>
  )
}
